var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5018 40.2806C21.3614 38.3471 42.4065 27.8532 42.4065 35.2114C42.4065 41.332 31.992 48.5 23.2276 48.5C14.3831 48.3562 8.70351 45.6414 3.60448 41.3207C3.40372 41.1469 3.63056 40.8433 3.88027 40.9397C7.58286 42.3681 11.8623 41.4154 15.5018 40.2806ZM8.01455 13.309C10.573 10.0519 11.1724 15.3216 16.9304 18.5596C24.1365 22.7615 33.3475 20.5673 40.7263 24.4104C44.9494 27.0045 42.2656 29.2906 38.0529 29.5388C29.6301 30.0478 20.9205 31.9614 13.5074 34.3806C8.71482 35.8397 3.88028 36.009 1.96373 34.1423C-3.74492 28.4861 4.45742 17.9727 8.01455 13.309ZM29.0046 0.5C39.4562 0.5 48 18.0476 48 28.5109C48 30.2775 46.3713 30.2776 46.3712 28.5953C46.3712 21.9665 39.6993 16.6382 27.5124 16.6382C22.1008 16.6382 16.0589 13.309 16.0589 8.50992C16.0589 3.97726 19.9258 0.500002 29.0046 0.5Z",
    fill: "#6A6E62"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/LogoIcon.a429da033536b701dc8cadbde95c3ecc.svg";
export { ForwardRef as ReactComponent };